<template lang="pug">
  .module__main
    .module__title Настройки
    .module-content__container(v-loading="isLoading")
      .settings__container
        .setting__container
          .general-setting__container.one-line
            .setting__title Статус работы
            el-switch(v-model="workStatus" @change="editSetting('workStatus', true)")
          .general-setting__container
            .setting__title Процент прибыли (от суммы заявки)
            .payment-setting__value
              el-input(v-model="profitPercent" type="number")
              el-button(
                type="primary"
                @click="editSetting('profitPercent')"
              ) Изменить
          .general-setting__container
            .setting__title Время ожидания сделки Bridge
            .payment-setting__value
              el-input(v-model="bridgeCreateDealTimeout" type="number")
              el-button(
                type="primary"
                @click="editSetting('bridgeCreateDealTimeout')"
              ) Изменить
          .general-setting__container.one-line
            .setting__title Автоматическое вкл/откл платежных систем
            el-switch(v-model="activePaymentSystemsStateAutoChanger" @change="editSetting('activePaymentSystemsStateAutoChanger', true)")
          .general-setting__container.one-line
            .setting__title Сеть для работы с обменкой
            el-select(v-model="networkMethod" @change="editSetting('networkMethod')")
              el-option(label="Тор" value="tor")
              el-option(label="Клир" value="network")
        .setting__container
          .setting__title Приоритет обработчиков
          .payment-settings__list
            .payment-setting__container(
              v-for="(setting, system) in handlersPriority"
              :key="`handler-priority-${system}`"
            )
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .handlers-priority__container
                  .handler-priority__container(v-for="(handler, index) in handlersPriority[system]" :key="`handler-priority-${system}-${handler}`")
                    .handler__name {{ handler }}
                    .handler-priority__btns
                      el-button(
                        v-if="index !== 0"
                        circle
                        size="mini"
                        icon="el-icon-top"
                        @click="changeHandlerPriority(index, index - 1, system)"
                      )
                      el-button(
                        v-if="index !== handlersPriority[system].length - 1"
                        circle
                        size="mini"
                        icon="el-icon-bottom"
                        @click="changeHandlerPriority(index, index + 1, system)"
                      )
                      el-button(
                        circle
                        size="mini"
                        icon="el-icon-delete"
                        @click="deleteHandlerPriorityFromSystem(index, system)"
                        type="danger"
                      )
                  .handler-add__container(v-if="handlersPriorityLeftSystems[system].available")
                    el-select(v-model="addingHandlersPriority[system]")
                      el-option(
                        v-for="addingHandler in handlersPriorityLeftSystems[system].list"
                        :label="addingHandler"
                        :value="addingHandler"
                        :key="`adding-handler-${system}-${addingHandler}`"
                        size="mini"
                      )
                    .handler-add__btn
                      el-button(
                        circle
                        icon="el-icon-plus"
                        size="mini"
                        :disabled="!addingHandlersPriority[system]"
                        @click="addHandlerPriorityToSystem(system)"
                        type="success"
                      )
        .setting__container
          .setting__title Приоритет платежных методов Saudi
          .payment-settings__list
            .payment-setting__container(
              v-for="(setting, system) in saudiPaymentSystemsExchangePriority"
              :key="`saudi-payment-system-exchange-priority-${system}`"
            )
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .handlers-priority__container
                  .handler-priority__container(v-for="(method, index) in saudiPaymentSystemsExchangePriority[system]" :key="`saudi-payment-system-exchange-priority-${system}-${method}`")
                    .handler__name {{ saudiPaymentMethods[method] || method }}
                    .handler-priority__btns
                      el-button(
                        v-if="index !== 0"
                        circle
                        size="mini"
                        icon="el-icon-top"
                        @click="changeHandlerPaymentSystemExchangePriority(index, index - 1, system)"
                      )
                      el-button(
                        v-if="index !== saudiPaymentSystemsExchangePriority[system].length - 1"
                        circle
                        size="mini"
                        icon="el-icon-bottom"
                        @click="changeHandlerPaymentSystemExchangePriority(index, index + 1, system)"
                      )
                      el-button(
                        circle
                        size="mini"
                        icon="el-icon-delete"
                        @click="deleteHandlerPaymentSystemExchangePriorityFromSystem(index, system)"
                        type="danger"
                      )
                      el-button.interbank-exclude-banks-ids__btn(
                        v-if="system === 'interbank'"
                        circle
                        size="mini"
                        @click="activateSaudiPaymentSystemsExcludeBanksIdsEdit(system, method)"
                      ) {{ saudiPaymentSystemsInterbankExcludeBanksIds[method]?.length || 0 }}
                      el-button.interbank-exclude-banks-ids__btn(
                        v-else-if="system === 'qr_interbank'"
                        circle
                        size="mini"
                        @click="activateSaudiPaymentSystemsExcludeBanksIdsEdit(system, method)"
                      ) {{ saudiPaymentSystemsQrInterbankExcludeBanksIds[method]?.length || 0 }}
                  .handler-add__container(v-if="handlersPaymentSystemsExchangePriorityLeftSystems[system].available")
                    el-select(v-model="addingSaudiPaymentSystemExchangePriority[system]")
                      el-option(
                        v-for="addingMethod in handlersPaymentSystemsExchangePriorityLeftSystems[system].list"
                        :label="addingMethod.alias"
                        :value="addingMethod.name"
                        :key="`adding-payment-method-${system}-${addingMethod.name}`"
                        size="mini"
                      )
                    .handler-add__btn
                      el-button(
                        circle
                        icon="el-icon-plus"
                        size="mini"
                        :disabled="!addingSaudiPaymentSystemExchangePriority[system]"
                        @click="addHandlerPaymentSystemExchangePriorityToSystem(system)"
                        type="success"
                      )
        .setting__container
          .setting__title Минимальная наценка к курсу
          .payment-settings__list
            .payment-setting__container(v-for="(setting, system) in minRatePercent" :key="`min-rate-percent-${system}`")
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .token__value
                  el-input(v-model="minRatePercent[system]" type="number")
                .payment-edit__button
                  el-button(
                    type="primary"
                    @click="editPaymentsSettings('minRatePercent')"
                  ) Изменить
        .setting__container
          .setting__title Время отказа (сек)
          .payment-settings__list
            .payment-setting__container(v-for="(setting, system) in orderRefuseTime" :key="`order-refuse-${system}`")
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .token__value
                  el-input(v-model="orderRefuseTime[system]")
                .payment-edit__button
                  el-button(
                    type="primary"
                    @click="editPaymentsSettings('orderRefuseTime')"
                  ) Изменить
        .setting__container
          .setting__title Максимальное отклонение суммы заявки (%)
          .payment-settings__list
            .payment-setting__container(v-for="(setting, system) in fiatAmountDeviationPercent" :key="`fiat-amount-deviation-percent-${system}`")
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .token__value
                  el-input(v-model="fiatAmountDeviationPercent[system]")
                .payment-edit__button
                  el-button(
                    type="primary"
                    @click="editPaymentsSettings('fiatAmountDeviationPercent')"
                  ) Изменить
        .setting__container
          .setting__title Блокировка новорегов
          .payment-settings__list
            .payment-setting__container(v-for="(setting, system) in blockNewUsersOrders" :key="`block-new-users-orders-${system}`")
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                el-switch(v-model="blockNewUsersOrders[system]" @change="editPaymentsSettings('blockNewUsersOrders')")
        .setting__container
          .setting__title Антиспам
          .setting__block
            .setting-block__title Использовать ЧС для проверки клиентов
            el-switch(v-model="useClientsBlacklist" @change="editSetting('useClientsBlacklist', true)")
          .setting__block
            .setting-block__title Максимальная сумма заявки
            .payment-setting__value
              el-input(v-model="maxOrderFiatAmount" type="number")
              .payment-edit__button
                el-button(
                  type="primary"
                  @click="editSetting('maxOrderFiatAmount')"
                ) Изменить
          .setting__block
            .setting-block__title Минимальное время с создания акккаунта (ч.)
            .payment-setting__value
              el-input(v-model="accountExistMinHours" type="number")
              .payment-edit__button
                el-button(
                  type="primary"
                  @click="editSetting('accountExistMinHours')"
                ) Изменить
          .setting__block
            .setting-block__title Максимальное количество отмененных заявок (без завершенных)
            .payment-setting__value
              el-input(v-model="clientMaxCanceledOrders" type="number")
              .payment-edit__button
                el-button(
                  type="primary"
                  @click="editSetting('clientMaxCanceledOrders')"
                ) Изменить
          .setting__block
            .setting-block__title Активных заявок для автоматической активации системы
            .payment-setting__value
              el-input(v-model="activeOrdersToActivateAntispam" type="number")
              .payment-edit__button
                el-button(
                  type="primary"
                  @click="editSetting('activeOrdersToActivateAntispam')"
                ) Изменить
        .setting__container
          .setting__title Токены авторизации
          .general-setting__container
            .payment-setting__title Saudi
            .payment-setting__value
              .token__value
                el-input(v-model="saudiPaymentToken")
              .payment-edit__button
                el-button(
                  type="primary"
                  @click="editSetting('saudiPaymentToken')"
                ) Изменить
          .general-setting__container
            .payment-setting__title Emirates
            .payment-setting__value
              .token__value
                el-input(v-model="emiratesPaymentToken")
              .payment-edit__button
                el-button(
                  type="primary"
                  @click="editSetting('emiratesPaymentToken')"
                ) Изменить
          .general-setting__container
            .payment-setting__title Токен авторизации Honey
            .payment-setting__value
              .token__value
                el-input(v-model="honeyAuthToken")
              .payment-edit__button
                el-button(
                  type="primary"
                  @click="editSetting('honeyAuthToken')"
                ) Изменить
          .general-setting__container
            .payment-setting__title Ключ подписи Honey
            .payment-setting__value
              .token__value
                el-input(v-model="honeySignKey")
              .payment-edit__button
                el-button(
                  type="primary"
                  @click="editSetting('honeySignKey')"
                ) Изменить
        .setting__container
          .setting__title Токены авторизации BR
          .payment-settings__list
            .payment-setting__container(v-for="(setting, system) in bridgePaymentTokens" :key="`bridge-payment-token-${system}`")
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .token__value
                  el-input(v-model="bridgePaymentTokens[system]")
                .payment-edit__button
                  el-button(
                    type="primary"
                    @click="editPaymentsSettings('bridgePaymentTokens')"
                  ) Изменить
        .setting__container
          .setting__title Секретные ключи BR
          .payment-settings__list
            .payment-setting__container(v-for="(setting, system) in bridgeSecretKeys" :key="`bridge-secret-key-${system}`")
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .token__value
                  el-input(v-model="bridgeSecretKeys[system]")
                .payment-edit__button
                  el-button(
                    type="primary"
                    @click="editPaymentsSettings('bridgeSecretKeys')"
                  ) Изменить
    el-dialog(:visible.sync="showSaudiPaymentSystemsExcludeBanksIdsEdit" :before-close="resetSaudiPaymentSystemsExcludeBanksIdsEdit" :title="saudiPaymentSystemsExcludeBanksIdsEditTitle" width="40%")
      el-checkbox-group.banks-ids__list(v-model="saudiPaymentSystemsExcludeBanksIdsEdit.banks")
        el-checkbox.exclude-bank(v-for="bank in banksList" :label="bank.id" :key="`exclude-bank-${bank.id}`") {{bank.name}}
      .exchange-finish__buttons
        el-button(type="success" @click="updateSaudiPaymentSystemsExcludeBanksIds()") Обновить
        el-button(type="danger" @click="resetSaudiPaymentSystemsExcludeBanksIdsEdit()") Отменить
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { LOAD_SETTINGS, UPDATE_SETTING } from '../../store/const/settings';
import { LOAD_BANKS_LIST } from '../../store/const/exchange';

export default {
  name: 'Settings',
  data() {
    return {
      workStatus: false,
      saudiPaymentToken: '',
      emiratesPaymentToken: '',
      bridgePaymentTokens: {
        'card': '',
        'sim': '',
        'sbp': '',
        'bank_account': '',
        'foreign_card': '',
        'foreign_sbp': '',
        'qr': '',
        'interbank': '',
        'qr_interbank': '',
      },
      bridgeSecretKeys: {
        'card': '',
        'sim': '',
        'sbp': '',
        'bank_account': '',
        'foreign_card': '',
        'foreign_sbp': '',
        'qr': '',
        'interbank': '',
        'qr_interbank': '',
      },
      honeyAuthToken: '',
      honeySignKey: '',
      partnerProfitPercent: {},
      minRatePercent: {},
      orderRefuseTime: {},
      fiatAmountDeviationPercent: {},
      profitPercent: 0,
      blockNewUsersOrders: {
        card: false,
        sim: false,
        sbp: false,
        bank_account: false,
        foreign_card: false,
        foreign_sbp: false,
        qr: false,
        interbank: false,
        qr_interbank: false,
      },
      useClientsBlacklist: false,
      maxOrderFiatAmount: 15000,
      accountExistMinHours: 0,
      clientMaxCanceledOrders: 20,
      activeOrdersToActivateAntispam: 150,
      handlers: ['saudi', 'emirates', 'honey', 'bridge'],
      handlersPriority: {
        card: [],
        sbp: [],
        sim: [],
        bank_account: [],
        foreign_card: [],
        foreign_sbp: [],
        qr: [],
        interbank: [],
        qr_interbank: [],
      },
      saudiPaymentSystems: [],
      saudiPaymentSystemsExchangePriority: {
        card: [],
        sbp: [],
        sim: [],
        bank_account: [],
        foreign_card: [],
        foreign_sbp: [],
        qr: [],
        interbank: [],
        qr_interbank: [],
      },
      addingHandlersPriority: {
        card: '',
        sbp: '',
        sim: '',
        bank_account: '',
        foreign_card: '',
        foreign_sbp: '',
        qr: '',
        interbank: '',
        qr_interbank: '',
      },
      addingSaudiPaymentSystemExchangePriority: {
        card: '',
        sbp: '',
        sim: '',
        bank_account: '',
        foreign_card: '',
        foreign_sbp: '',
        qr: '',
        interbank: '',
        qr_interbank: '',
      },
      activePaymentSystemsStateAutoChanger: false,
      networkMethod: 'tor',
      bridgeCreateDealTimeout: 20,
      saudiPaymentSystemsInterbankExcludeBanksIds: {},
      saudiPaymentSystemsQrInterbankExcludeBanksIds: {},
      saudiPaymentSystemsExcludeBanksIdsEdit: {
        payment_system: undefined,
        payment_method: undefined,
        banks: [],
      },
    };
  },
  async mounted() {
    await this.loadAndSetSettings();
    await this.loadBanksList();
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('settings', [
      'paymentSystems',
    ]),
    ...mapGetters('exchange', [
      'banksList',
    ]),
    isLoading() {
      return this.loading(LOAD_SETTINGS) === 'loading';
    },
    isError() {
      return this.loading(LOAD_SETTINGS) === 'error';
    },
    errorMessage() {
      return this.error(LOAD_SETTINGS);
    },
    handlersPriorityLeftSystems() {
      const result = {};
      for (const system of Object.keys(this.paymentSystems)) {
        const handlersLeft = this.handlers.filter((handler) => !this.handlersPriority[system].includes(handler));
        result[system] = { available: handlersLeft.length > 0, list: handlersLeft };
      }
      return result;
    },
    handlersPaymentSystemsExchangePriorityLeftSystems() {
      const result = {};
      for (const system of Object.keys(this.paymentSystems)) {
        const handlersLeft = this.saudiPaymentSystems.filter((method) => !this.saudiPaymentSystemsExchangePriority[system].includes(method.name));
        result[system] = { available: handlersLeft.length > 0, list: handlersLeft };
      }
      return result;
    },
    saudiPaymentMethods() {
      const result = {};
      for (const method of this.saudiPaymentSystems) {
        result[method.name] = method.alias;
      }
      return result;
    },
    showSaudiPaymentSystemsExcludeBanksIdsEdit() {
      return !!this.saudiPaymentSystemsExcludeBanksIdsEdit.payment_system;
    },
    saudiPaymentSystemsExcludeBanksIdsEditTitle() {
      return `Настройка исключений банков платежной системы ${this.paymentSystems[this.saudiPaymentSystemsExcludeBanksIdsEdit.payment_system]} для метода ${this.saudiPaymentMethods[this.saudiPaymentSystemsExcludeBanksIdsEdit.payment_method]}`;
    },
  },
  methods: {
    ...mapActions('settings', {
      loadSettings: LOAD_SETTINGS,
      updateSetting: UPDATE_SETTING,
    }),
    ...mapActions('exchange', {
      loadBanksList: LOAD_BANKS_LIST,
    }),
    async loadAndSetSettings() {
      const request = await this.loadSettings();
      if (request.success) {
        const settings = request.data;
        for (const settingName of Object.keys(settings)) {
          this[settingName] = settings[settingName];
        }
      }
    },
    async requestSettingUpdate(name, setting) {
      const request = await this.updateSetting({ name, setting });
      if (request.success) {
        this.$message.success('Настройки успешно обновлены');
        await this.loadAndSetSettings();
        return true;
      } else {
        this.$message.error(`Ошибка обновления настроек: ${request.message || 'Неизвестная ошибка'}`);
        return false;
      }
    },
    async editPaymentsSettings(settingsName) {
      return await this.requestSettingUpdate(settingsName, this[settingsName]);
    },
    async editSetting(settingsName, switchOnFail) {
      const isUpdateSuccess = await this.requestSettingUpdate(settingsName, this[settingsName]);
      if (!isUpdateSuccess && switchOnFail) {
        this[settingsName] = !this[settingsName];
      }
    },
    async changeHandlerPriority(index, newIndex, system) {
      this.swapHandlerPriority(index, newIndex, system);
      const wasChanged = await this.editPaymentsSettings('handlersPriority');
      if (!wasChanged) {
        this.swapHandlerPriority(index, newIndex, system);
      }
    },
    swapHandlerPriority(index, newIndex, system) {
      const oldValue = this.handlersPriority[system][index];
      const newPriority = [...this.handlersPriority[system]];

      newPriority[index] = newPriority[newIndex];
      newPriority[newIndex] = oldValue;

      this.handlersPriority[system] = newPriority;
    },
    async addHandlerPriorityToSystem(system) {
      if (this.handlersPriority[system].includes(this.addingHandlersPriority[system])) {
        return this.$message.warning('Указанный обработчик уже используется в приоритезации платежной системы');
      }
      this.handlersPriority[system].push(this.addingHandlersPriority[system]);
      const wasChanged = await this.editPaymentsSettings('handlersPriority');
      if (wasChanged) {
        this.addingHandlersPriority[system] = '';
      } else {
        this.handlersPriority[system].splice(this.handlersPriority[system].length - 1, 1);
      }
    },
    async deleteHandlerPriorityFromSystem(index, system) {
      this.$confirm(`Вы уверены, что хотите удалить обработчик ${this.handlersPriority[system][index]} из платежной системы ${system}?`, 'Подтверждение').then(async () => {
        const oldPriority = [...this.handlersPriority[system]];
        this.handlersPriority[system].splice(index, 1);
        const wasChanged = await this.editPaymentsSettings('handlersPriority');
        if (!wasChanged) {
          this.handlersPriority[system] = oldPriority;
        }
      }).catch(() => {
        this.$message.info('Удаление отменено');
      });
    },
    async changeHandlerPaymentSystemExchangePriority(index, newIndex, system) {
      this.swapHandlerPaymentSystemExchangePriority(index, newIndex, system);
      const wasChanged = await this.editPaymentsSettings('saudiPaymentSystemsExchangePriority');
      if (!wasChanged) {
        this.swapHandlerPaymentSystemExchangePriority(index, newIndex, system);
      }
    },
    swapHandlerPaymentSystemExchangePriority(index, newIndex, system) {
      const oldValue = this.saudiPaymentSystemsExchangePriority[system][index];
      const newPriority = [...this.saudiPaymentSystemsExchangePriority[system]];

      newPriority[index] = newPriority[newIndex];
      newPriority[newIndex] = oldValue;

      this.saudiPaymentSystemsExchangePriority[system] = newPriority;
    },
    async addHandlerPaymentSystemExchangePriorityToSystem(system) {
      if (this.saudiPaymentSystemsExchangePriority[system].includes(this.addingSaudiPaymentSystemExchangePriority[system])) {
        return this.$message.warning('Указанный платежный метод уже используется в приоритезации платежной системы');
      }
      this.saudiPaymentSystemsExchangePriority[system].push(this.addingSaudiPaymentSystemExchangePriority[system]);
      const wasChanged = await this.editPaymentsSettings('saudiPaymentSystemsExchangePriority');
      if (wasChanged) {
        this.addingSaudiPaymentSystemExchangePriority[system] = '';
      } else {
        this.saudiPaymentSystemsExchangePriority[system].splice(this.saudiPaymentSystemsExchangePriority[system].length - 1, 1);
      }
    },
    async deleteHandlerPaymentSystemExchangePriorityFromSystem(index, system) {
      const methodName = this.saudiPaymentMethods[this.saudiPaymentSystemsExchangePriority[system][index]] || this.saudiPaymentSystemsExchangePriority[system][index];
      const paymentSystemName = this.paymentSystems[system] || system;
      this.$confirm(`Вы уверены, что хотите метод ${methodName} из платежной системы ${paymentSystemName}?`, 'Подтверждение').then(async () => {
        const oldPriority = [...this.saudiPaymentSystemsExchangePriority[system]];
        this.saudiPaymentSystemsExchangePriority[system].splice(index, 1);
        const wasChanged = await this.editPaymentsSettings('saudiPaymentSystemsExchangePriority');
        if (!wasChanged) {
          this.saudiPaymentSystemsExchangePriority[system] = oldPriority;
        }
      }).catch(() => {
        this.$message.info('Удаление отменено');
      });
    },
    activateSaudiPaymentSystemsExcludeBanksIdsEdit(payment_system, payment_method) {
      this.saudiPaymentSystemsExcludeBanksIdsEdit.payment_system = payment_system;
      this.saudiPaymentSystemsExcludeBanksIdsEdit.payment_method = payment_method;
      const saudiPaymentSystemsExcludeBanksIds = payment_system === 'interbank'
        ? this.saudiPaymentSystemsInterbankExcludeBanksIds
        : this.saudiPaymentSystemsQrInterbankExcludeBanksIds;
      this.saudiPaymentSystemsExcludeBanksIdsEdit.banks = [...(saudiPaymentSystemsExcludeBanksIds[payment_method] || [])];
    },
    resetSaudiPaymentSystemsExcludeBanksIdsEdit() {
      this.saudiPaymentSystemsExcludeBanksIdsEdit.payment_system = undefined;
      this.saudiPaymentSystemsExcludeBanksIdsEdit.payment_method = undefined;
      this.saudiPaymentSystemsExcludeBanksIdsEdit.banks = [];
    },
    async updateSaudiPaymentSystemsExcludeBanksIds() {
      const updateParentObject = this.saudiPaymentSystemsExcludeBanksIdsEdit.payment_system === 'interbank'
        ? this.saudiPaymentSystemsInterbankExcludeBanksIds
        : this.saudiPaymentSystemsQrInterbankExcludeBanksIds;
      const updateObject = {
        ...updateParentObject,
        [this.saudiPaymentSystemsExcludeBanksIdsEdit.payment_method]: this.saudiPaymentSystemsExcludeBanksIdsEdit.banks
      };
      const updateSettingName = this.saudiPaymentSystemsExcludeBanksIdsEdit.payment_system === 'interbank'
        ? 'saudiPaymentSystemsInterbankExcludeBanksIds'
        : 'saudiPaymentSystemsQrInterbankExcludeBanksIds';
      const isRequestSuccess = await this.requestSettingUpdate(updateSettingName, updateObject);
      if (isRequestSuccess) {
        this.resetSaudiPaymentSystemsExcludeBanksIdsEdit();
      }
    },
  }
};
</script>
<style scoped>
.settings__container {
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
}

.setting__container {
  width: 280px;
  padding: 10px;
  background-color: white;
  margin: 5px;
  border-radius: 5px;
  box-shadow: 1px 1px 1px #9f9f9f
}

.setting__title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
}

.setting__block {
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
  margin-bottom: 5px;
}

.setting-block__title {
  font-weight: 500;
  flex: 1;
}

.handlers-priority__container {
  border: 1px solid #dcdfe6;
  border-radius: 5px;
}

.handler-priority__container {
  display: flex;
  padding: 4px;
  margin-bottom: 2px;
  align-items: center;
  justify-content: space-between;
}

.handler-priority__btns {
  margin-left: 5px;
}

.handler-add__container {
  display: flex;
  align-items: center;
}

.handler-add__btn {
  width: 30px;
  height: 30px;
  margin: auto 5px;
}

.general-setting__container {
  margin-bottom: 10px;
  padding: 5px;
}

.general-setting__container:first-child {
  padding-top: 0;
}

.general-setting__container.one-line {
  display: flex;
  align-items: center;
}

.general-setting__container.one-line .setting__title {
  margin-right: 5px;
  margin-bottom: 0;
}

.payment-setting__container {
  margin-bottom: 5px;
}

.payment-setting__value {
  display: flex;
}

.banks-ids__list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 2px;
  align-items: start;
}

.exclude-bank {
  display: flex;
  align-items: flex-start;
  gap: 4px;

  min-width: 0;
  font: 16px/1.3 Arial, sans-serif;
  color: #555;
  cursor: pointer;
  overflow: hidden;
}
</style>
